import React from 'react';
import { Section } from '../ui/Section';
export function FinalClose() {
  return <Section background="dark" className="text-center pb-32" data-id="element-9">
      <div className="max-w-2xl mx-auto" data-id="element-10">
        <p className="text-xl md:text-2xl text-gray-300 font-serif italic mb-8 leading-relaxed" data-id="element-11">
          "Si llevas semanas (o años) tratando de dormir 'a pesar' de tus
          manos... no necesitas más fuerza."
        </p>

        <p className="text-lg text-[#f5f0e8]" data-id="element-12">
          Necesitas un plan que funcione cuando estás cansada.
        </p>
      </div>
    </Section>;
}